<script>
  import { tick } from "svelte";

  export let id;
  export let value = "round-2";

  const options = [
    { value: "round-1", label: "Round 1" },
    { value: "round-2", label: "Round 2" },
  ];

  let root;
  let trigger;
  let open = false;

  $: selectedOption =
    options.find((option) => option.value === value) || options[0];

  function toggleDropdown() {
    open = !open;
  }

  function selectOption(option) {
    value = option.value;
    open = false;
    trigger?.focus();
  }

  function handleWindowClick(event) {
    if (open && root && !root.contains(event.target)) open = false;
  }

  function getOptionButtons() {
    return Array.from(root?.querySelectorAll(".round-select__option") || []);
  }

  async function handleKeydown(event) {
    if (event.key === "Escape" && open) {
      event.preventDefault();
      open = false;
      trigger?.focus();
      return;
    }

    if (event.target === trigger && ["ArrowDown", "ArrowUp"].includes(event.key)) {
      event.preventDefault();
      open = true;
      await tick();

      const optionButtons = getOptionButtons();
      const selectedIndex = Math.max(
        options.findIndex((option) => option.value === value),
        0
      );

      optionButtons[selectedIndex]?.focus();
      return;
    }

    if (!open) return;

    if (event.key === "Tab") {
      open = false;
      return;
    }

    const optionButtons = getOptionButtons();
    const currentIndex = optionButtons.indexOf(document.activeElement);
    if (
      currentIndex < 0 ||
      !["ArrowDown", "ArrowUp", "Home", "End"].includes(event.key)
    ) return;

    event.preventDefault();
    const nextIndex = {
      ArrowDown: (currentIndex + 1) % optionButtons.length,
      ArrowUp: (currentIndex - 1 + optionButtons.length) % optionButtons.length,
      Home: 0,
      End: optionButtons.length - 1,
    }[event.key];

    optionButtons[nextIndex]?.focus();
  }
</script>

<svelte:window on:click={handleWindowClick} />

<div
  class:round-select--open={open}
  class="round-select"
  bind:this={root}
  on:keydown={handleKeydown}
>
  <button
    class="round-select__trigger"
    {id}
    type="button"
    aria-label="Select SCORE round"
    aria-haspopup="listbox"
    aria-expanded={open}
    aria-controls={`${id}-options`}
    bind:this={trigger}
    on:click={toggleDropdown}
  >
    <span class="round-select__value">{selectedOption.label}</span>
    <img
      class="round-select__chevron"
      src="assets/filter-chevron.svg"
      alt=""
      aria-hidden="true"
    />
  </button>

  <ul
    class:round-select__dropdown--open={open}
    class="round-select__dropdown"
    id={`${id}-options`}
    role="listbox"
    aria-label="Select SCORE round"
    aria-hidden={!open}
  >
    {#each options as option (option.value)}
      <li class="round-select__item" role="presentation">
        <button
          class:round-select__option--selected={option.value === value}
          class="round-select__option"
          type="button"
          role="option"
          aria-selected={option.value === value}
          tabindex={open ? 0 : -1}
          on:click={() => selectOption(option)}
        >
          <span class="round-select__option-label">{option.label}</span>

          {#if option.value === value}
            <img
              class="round-select__check"
              src="assets/filter-check.svg"
              alt=""
              aria-hidden="true"
            />
          {/if}
        </button>
      </li>
    {/each}
  </ul>
</div>
